var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a8a8a8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.74,15.82c-.51-.65-12.7-15.82-28.16-15.82S.93,15.18.41,15.82c-.55.7-.55,1.68,0,2.38.51.65,12.7,15.82,28.16,15.82s27.65-15.18,28.16-15.82c.55-.7.55-1.68,0-2.38ZM52.71,17.01c-3.09,3.43-12.86,13.18-24.13,13.18S7.54,20.44,4.45,17.01c3.09-3.43,12.86-13.18,24.13-13.18s21.04,9.75,24.13,13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.57,7.04c-5.5,0-9.97,4.47-9.97,9.97s4.47,9.97,9.97,9.97,9.97-4.47,9.97-9.97-4.47-9.97-9.97-9.97ZM34.7,17.01c0,3.38-2.75,6.13-6.13,6.13s-6.13-2.75-6.13-6.13,2.75-6.13,6.13-6.13,6.13,2.75,6.13,6.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.8a353cf6c73b674d72aa122aca6bc986.svg";
export { ForwardRef as ReactComponent };